/** @flow */

import React, { Component } from "react";
import Chart from "react-google-charts";
import classNames from "classnames";
import type { ChartWrapperOptions } from "react-google-charts";
import { chartDefaultColors } from "@styles/colors";
import "./style.scss";

//https://developers.google.com/chart/interactive/docs/gallery/piechart#donut
const pieOptions: ChartWrapperOptions = {
  pieHole: 0.3,
  legend: {},
  chartArea: {
    top: 12,
    left: 12,
    width: "100%",
    height: "80%",
  },
  colors: chartDefaultColors,
  maximize: true,
};

export type Props = $Exact<{
  options?: Object,
  title?: string,
  fullWidth?: boolean,
  disableBorder?: boolean,
  values: Array<Array<string | number | Object>>,
}>;

export class DonutChart extends Component<Props> {
  chartWrapper = null;

  onResize = () => {
    this.chartWrapper && this.chartWrapper.draw();
  };
  componentDidMount() {
    window.addEventListener("resize", this.onResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.onResize);
  }

  render() {
    return (
      <div
        className={classNames(
          "item-container chart-block donut-chart mt-3 pt-3 d-flex flex-column",
          {
            "full-width": this.props.fullWidth,
            "disable-border": this.props.disableBorder,
          },
        )}
      >
        {this.props.title && <div className="chart-title mb-4 text-center">{this.props.title}</div>}
        {this.props.values.length > 1 ? (
          <Chart
            chartType="PieChart"
            data={this.props.values}
            getChartWrapper={chartWrapper => {
              this.chartWrapper = chartWrapper;
            }}
            options={Object.assign({}, pieOptions, this.props.options)}
          />
        ) : (
          <div className="w-100 text-center">No data</div>
        )}
      </div>
    );
  }
  static defaultProps = {
    options: {},
  };
}

export default DonutChart;
